import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './ProfileOverviewCard.css';

export interface ProfileOverviewRow {
  label: string;
  value: React.ReactNode;
}

interface ProfileOverviewCardProps {
  title: string;
  subtitle?: string;
  icon?: IconDefinition;
  accentColor?: string;
  rows: ProfileOverviewRow[];
  onEdit?: () => void;
  onReset?: () => void;
  editLabel?: string;
  resetLabel?: string;
}

const ProfileOverviewCard: React.FC<ProfileOverviewCardProps> = ({
  title,
  subtitle,
  icon,
  accentColor = '#7c3aed',
  rows,
  onEdit,
  onReset,
  editLabel = 'Edit',
  resetLabel = 'Reset',
}) => (
  <div className="poc-card">
    <div className="poc-header">
      <div className="poc-heading">
        {icon && (
          <span className="poc-icon" style={{ background: `${accentColor}14`, color: accentColor }}>
            <FontAwesomeIcon icon={icon} />
          </span>
        )}
        <div className="poc-heading-text">
          <h3 className="poc-title">{title}</h3>
          {subtitle && <p className="poc-subtitle">{subtitle}</p>}
        </div>
      </div>
      <div className="poc-actions">
        {onReset && (
          <button type="button" className="poc-btn poc-btn-danger" onClick={onReset}>
            <FontAwesomeIcon icon={faRotateLeft} /> {resetLabel}
          </button>
        )}
        {onEdit && (
          <button
            type="button"
            className="poc-btn poc-btn-primary"
            style={{ background: accentColor }}
            onClick={onEdit}
          >
            <FontAwesomeIcon icon={faPen} /> {editLabel}
          </button>
        )}
      </div>
    </div>
    <div className="poc-rows">
      {rows.map((row, i) => (
        <div className="poc-row" key={i}>
          <span className="poc-row-label">{row.label}</span>
          <span className="poc-row-value">{row.value}</span>
        </div>
      ))}
    </div>
  </div>
);

export default ProfileOverviewCard;
